/* eslint-disable */
import React from 'react'
import { useReactTable, getCoreRowModel, flexRender } from '@tanstack/react-table'
import { FormattedMessage } from 'react-intl'

import LoadingWrapper from 'components/LoadingWrapper'

import { TableStickyNoResultsWrapper, TableStickyStyles } from './style'

const TableSticky = ({ columns, data, width = '800px', height = '400px', noResultMessage = 'noResultsToShow', isLoading = false, lastElementRef }) => {

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  const {
    getHeaderGroups,
    getRowModel,
  } = table

  // Workaround as react-table footerGroups doesn't provide the same internal data than headerGroups
  //const footerGroups = headerGroups.slice().reverse()

  return (
    <TableStickyStyles isLoading={isLoading}>
      <div
        className='table sticky scroll'
        style={{ width: width, height: height }}
      >
        <div className='header'>
          {getHeaderGroups().map((headerGroup) => {
            return (
              <div key={headerGroup.id} className='tr'>
                {headerGroup.headers.map((header) => {
                  return (
                    <div key={header.id} className='th' style={header.column.columnDef.style}>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
        <LoadingWrapper size={'24px'} isLoading={isLoading} height={height} width={width}>
          <div className='body'>
            {getRowModel().rows.map((row, index) => {
              if (index + 1 === getRowModel().rows.length  && typeof lastElementRef !== 'undefined') {
                return (
                  <div key={row.id} className='tr' ref={lastElementRef}>
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <div key={cell.id} className='td' style={cell.column.columnDef.style}>
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </div>
                      )
                    })}
                  </div>
                )
              }
              return (
                <div key={row.id} className='tr'>
                  {row.getVisibleCells().map((cell) => {
                    return (
                      <div key={cell.id} className='td' style={cell.column.columnDef.style}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </LoadingWrapper>

        {!data.length && (
          <TableStickyNoResultsWrapper>
            <FormattedMessage id={noResultMessage} />
          </TableStickyNoResultsWrapper>
        )}
      </div>
    </TableStickyStyles>
  )
}

// const TableSticky = ({ columns, data, width, height , noResultMessage, isLoading, lastElementRef}) => {
//   return <Table columns={columns} data={data} width={width} height={height} isLoading={isLoading} noResultMessage={noResultMessage} lastElementRef={lastElementRef} />
// }

export default TableSticky
